<template>
  <v-row class="align-content-start no-gutters fill-height">
    <v-col cols="12">
      <v-card class="fill-height px-6" elevation="0">
        <div
          class="mt-0 icon-spacing d-flex flex-column justify-center align-center fill-height font-weight-regular text-subtitle-2"
        >
          <v-img
            src="https://cdn.opinew.com/logos/Opinew_logo_full.svg"
            contain
            height="120"
            class="my-8"
          />
          <v-img
            src="https://cdn.opinew.com/dashboard/images/responsive_view_image.svg"
            height="160"
            contain
            class="ml-6 pb-4"
          />
          <div class="text-center info--text font-weight-bold text-h5 ma-4">
            {{ $t('Account.mobileView.optimizedForLargerScreens') }}
          </div>
          <div class="text-h8 text-center">
            {{ $t('Account.mobileView.switchToLargerScreens') }}
          </div>
          <v-card class="fill-height py-6 my-6" elevation="1">
            <v-card-text class="black--text">
              <div class="text-center primary--text font-weight-bold mb-8">
                {{ accountInfo.shopName }}
                {{ $t('Account.mobileView.overview') }}
              </div>
              <v-row class="align-content-start no-gutters d-flex fill-height">
                <v-col cols="6" class="text-center pr-2">
                  <p class="text-h4 font-weight-bold">
                    {{ accountInfo.shopReviewStats.reviewNumber }}
                  </p>
                  {{ $t('Account.mobileView.reviewsInShop') }}
                </v-col>
                <v-col cols="6" class="text-center pl-2">
                  <p class="text-h4 font-weight-bold">
                    {{ accountInfo.shopReviewStats.averageStars }}
                  </p>
                  {{ $t('Account.mobileView.averageRating') }}
                </v-col>
              </v-row>
              <v-row class="align-content-start no-gutters pt-8 fill-height">
                <v-col cols="6" class="text-center pr-2">
                  <p class="text-h4 font-weight-bold">
                    {{ accountInfo.unansweredCount }}
                  </p>
                  {{ $t('Account.mobileView.questions') }}
                </v-col>
                <v-col cols="6" class="text-center pl-2">
                  <p class="text-h4 font-weight-bold">
                    {{ accountInfo.unpublishedCount }}
                  </p>
                  {{ $t('Account.mobileView.unpublishedReviews') }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <p-btn variant="primary" @click="$emit('continue', true)">
            {{ $t('Account.mobileView.continueAnyway') }}
          </p-btn>
          <div class="text-center black--text pt-6 pb-12 mb-16">
            {{ $t('Account.mobileView.contactOur') }}
            <span
              class="font-weight-bold"
              @click="
                trackAnalytics('Not mobile optimized - Live chat');
                openChat();
              "
            >
              {{ $t('Account.mobileView.supportTeam') }}
            </span>
            {{ $t('Account.mobileView.orCheckOut') }}
            <a
              href="https://www.opinew.com/help-center"
              target="_blank"
              class="text-decoration-none black--text"
            >
              <span class="font-weight-bold">{{ $t('Account.mobileView.helpCenter') }}</span>
            </a>
            {{ $t('Account.mobileView.toHelpYou') }}
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PBtn from '@/components/polaris/PBtn';

export default {
  name: 'NotMobileOptimized',
  components: { PBtn },
  computed: {
    ...mapState(['accountInfo']),
  },
  methods: {
    ...mapActions(['trackAnalytics']),
    openChat() {
      window.fcWidget.open();
    },
  },
};
</script>

<style scoped></style>
